import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { isAcceptablePdf } from 'src/app/utils/helper/utilities';
import { FormService } from 'src/app/utils/services/forms/forms.service';

@Component({
  selector: 'app-loa-uploader',
  templateUrl: './loa-uploader.component.html',
  styleUrls: ['./loa-uploader.component.scss']
})
export class LoaUploaderComponent implements OnInit {

  @Output()
  uploaded: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  patientID: any;

  document: any;
  modal = false;
  processing = false;
  tags: any = [];
  form: FormGroup;
  file: any;
  preview: any;
  name: string;
  md_id: any;
  confirmationModal = false;


  constructor(
    private service: FormService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.document?.id],
      patient_id: [this.patientID || '99999'],
      md_id: [this.document?.md_id, Validators.required],
      renamed: [this.document?.renamed],
      version: [this.document?.version],
      type: [this.document?.type],
      source: [this.document?.source || 'uploaded'],
      description: [this.document?.description],
      tags: [],
    });
  }

  previewUploadFile(event) {
    var id = event.target.id;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      if (!isAcceptablePdf(file?.type)) {
        this.toastr.error('File should be pdf', '', { timeOut: 1000 });
        return;
      }

      reader.readAsDataURL(file);

      reader.onload = () => {
        this.form.patchValue({
          type: file?.type
        })
        this.file = file;
        this.preview = reader.result as string;
      };
    }
  }


  onOpen(document = null) {
    this.document = document;
    this.preview = this.document?.url;
    this.modal = true;
    this.createForm();
    // // Explicitly set md_id control to null
    // this.form.get('md_id')?.setValue(null);
    // setTimeout(() => {
    //   this.updateTags();
    // }, 1);
  }

  onClose() {
    this.modal = false;
    this.file = null;
    this.name = null;
    this.md_id = null;
    this.preview = null;
    this.tags = [];
  }

  getControl(name) {
    return this.form.get(name);
  }

  async upload() {
    this.confirmationModal = false;
    this.processing = true;

    if (this.file) {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("disk", "public");
      formData.append("folder", "uploaded");
      formData.append("mimes", 'mimes:png,jpg,jpeg,png,bmp,gif,webp,image,pdf');

      try {
        const response: any = await this.service.upload(formData).toPromise();

        this.form.patchValue({
          renamed: response?.renamed
        });

        const pdfResponse = await this.service.getPDFToText({
          renamed: response?.renamed
        }).toPromise();

        this.form.patchValue({
          description: JSON.stringify(pdfResponse)
        });

        const formDataToSave = { ...this.form.value, name: this.form.get('name')?.value || 'Letter of Authorization' };

        this.service.saveFile(formDataToSave).subscribe(
          (response: any) => {
            this.toastr.success("Successfully uploaded the document");
            this.uploaded.emit(response);
            this.onClose();
          },
          (err) => {
            console.log(err);
            this.toastr.error("Error uploading document");
          }
        );
      } catch (error) {
        this.modal = true; // Reopen modal on error
      } finally {
        this.processing = false;

      }
    }
  }


  confirmUpload() {
    this.confirmationModal = true;
  }

  cancelUpload() {
    this.confirmationModal = false;
  }

}
